import { Subject } from 'rxjs';
import { filter, first } from 'rxjs/operators';
import { FedOpsInteraction } from '../../constants/FedOpsInteraction';
import { fedopsLogger } from '../../services/loggers/fedopsLogger';

export const imageLoad$ = new Subject<string>();

export const startInteractionLogging = (fileId: string) => {
  fedopsLogger.interactionStarted(FedOpsInteraction.ImageLoadedAfterMediaStudioSave);

  imageLoad$
    .pipe(
      filter((src) => src.includes(`/${fileId}/`)),
      first(),
    )
    .subscribe(() => {
      fedopsLogger.interactionEnded(FedOpsInteraction.ImageLoadedAfterMediaStudioSave);
    });
};
